/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_c740b4d3',
};

export = styles;

loadStyles([{"rawString":".root_c740b4d3{display:inline-block}"}]);
/* tslint:enable */